const SomaliaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112384)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#338AF3"
      />
      <path
        d="M20.0001 10.4346L22.1586 17.0775H29.1433L23.4925 21.1829L25.6509 27.8259L20.0001 23.7204L14.3494 27.8259L16.5078 21.1829L10.8569 17.0775H17.8417L20.0001 10.4346Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112384">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SomaliaSvg;
